import debounce from 'lodash.debounce';
import { useEffect, useMemo } from 'react';
import { useLatest } from './useLatest';
export function useDebounceFn(fn, options) {
    var _a;
    const fnRef = useLatest(fn);
    const wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
    const debounced = useMemo(() => debounce((...args) => {
        return fnRef.current(...args);
    }, wait, options), []);
    useEffect(() => {
        return () => {
            debounced.cancel();
        };
    }, []);
    return {
        run: debounced,
        cancel: debounced.cancel,
        flush: debounced.flush,
    };
}
